export default __webpack_public_path__ + "static/media/blackFriday.ed7ff89c.webp";